export default {
  SET_NOTIFICATION(state, payload) {
    state.notification = payload;
  },
  CLEAR_NOTIFICATION(state) {
    state.notification = null;
  },
};
